// Crochet Match picker: the chosen size (a real variant) becomes the product form's `id`,
// and every color swatch link keeps pointing at that same size in the other color.
class SMatchSelector extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches('[data-match-size]')) this.#sync();
    }, { signal: this.#ac.signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const picked = this.querySelector('input[data-match-size]:checked');
    if (!(picked instanceof HTMLInputElement)) return;

    const form = this.closest('form');
    const idInput = form?.elements.namedItem('id');
    if (idInput instanceof HTMLInputElement) idInput.value = picked.value;

    const index = Number(picked.dataset.index || 0);
    for (const link of this.querySelectorAll('a[data-match-color]')) {
      if (!(link instanceof HTMLAnchorElement)) continue;
      const ids = String(link.dataset.variantIds || '').split(',').filter(Boolean);
      const target = ids[index] || ids[0];
      const base = link.dataset.baseUrl || link.getAttribute('href') || '';
      link.href = target ? `${base}?variant=${target}` : base;
    }
  }
}

if (!customElements.get('s-match-selector')) {
  customElements.define('s-match-selector', SMatchSelector);
}
